import dbdexie from './db.js'
var tools = require('./tools.js')

export async function get(url, dt = 7200, includeheaders = true) {
  // time in seconds
  var deltatime
  var response = await dbdexie.request.get({ url })
  if (!navigator.onLine) {
    return JSON.parse(response.response || '{}')
  }
  if (response === undefined) {
    deltatime = dt + 100
  } else {
    deltatime = (Date.now() - response.time || 0) / 1000 // seconds
  }
  var isupdated = false

  if (deltatime >= dt) {
    try {
      if (response === undefined) {
        await updatedexie(url, includeheaders)
        isupdated = true
      } else {
        updatedexie(url, includeheaders)
      }
    } catch (error) {
      return {}
    }
  }
  if (response === undefined && !isupdated) {
    return {}
  }
  response = await dbdexie.request.get({ url })
  try {
    return JSON.parse(response.response || '{}')
  } catch (event) {
    return {}
  }
}

async function updatedexie(url, includeheaders) {
  return await tools.get(url, includeheaders).then((response) => {
    dbdexie.request.put({
      url: url,
      time: Date.now(),
      response: JSON.stringify(response)
    })
  })
}
